import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Icon, LinkText } from '../../index'
import './toast.scss';

export const Toast = ({
    autoClose = true, // Toasts should auto close by default but this can be overridden
    autoCloseDelay = 45000,
    colorStyle = 'default',
    children,
    icon,
    open,
    onCloseClick, // Function to display close x button
    toggle, // Function to toggle auto close
    link
}) => {

    useEffect(() => {
        if (open && autoClose && autoCloseDelay) {
            const toastTimeout = setTimeout(() => {
                if (open) {
                    toggle();
                }
            }, autoCloseDelay);
            return () => clearTimeout(toastTimeout);
        }
    }, [open]);

    const toastColor = {
        default: {
            iconColor: '$color-primary-c1',
            msgColor: '$color-primary-c1',
            closeColor: '$color-primary-c1',
        },
        error: {
            iconColor: '$color-system-b1',
            msgColor: '$color-primary-a2',
            closeColor: '$color-primary-a2',
        },
    };
    const linkContent = link 
        ? <div className="bsw-toast__link" >
            <LinkText
                href={link.href}
                to={link.to}
                onClick={link.onClick}
                target={link.target}
                as={link.as}
                type={link.type}
                color={toastColor[colorStyle]['msgColor']}
                overrideHoverColor
                typographyProps={{ underline: true }}
            >
                {link.label}
            </LinkText>
        </div>
        : null;

    const toastClasses = [
        `bsw-toast`,
        `bsw-toast-color--${colorStyle}`,
    ].join(' ');

    return (open && children)
        ? <div className={toastClasses}>
            <div className="bsw-toast__content">
                {icon &&
                    <div className="bsw-toast__icon">
                        <Icon name={icon} color={toastColor[colorStyle]['iconColor']} />
                    </div>
                }
                <div className={`bsw-toast__message${link ? ' has-link' : ''}`}>
                    <div className="bsw-toast__message-body">
                        <Typography
                            type="body-01"
                            color={toastColor[colorStyle]['msgColor']}
                            textAlign="left"
                        >
                            {children}
                        </Typography>
                    </div>
                    {linkContent}
                </div>
                {onCloseClick &&
                    <div className="bsw-toast__close">
                        <button
                            type="button"
                            aria-label="close button"
                            className="bsw-toast__close-button"
                        >
                            <Icon
                                color={toastColor[colorStyle]['closeColor']}
                                name="x"
                                onClick={onCloseClick}
                            />
                        </button>
                    </div>
                }
            </div>
        </div>
        : null
        ;
}

Toast.propTypes = {
    autoClose: PropTypes.bool,
    autoCloseDelay: PropTypes.number,
    colorStyle: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    icon: PropTypes.string,
    open: PropTypes.bool,
    onCloseClick: PropTypes.func,
    toggle: PropTypes.func,
    link: PropTypes.object,
}
